var map = {
	"./ARSearch.svg": 512,
	"./AgencyApFundDetailRpt.svg": 542,
	"./AgencyDownload.svg": 7394,
	"./AgencyHelpCenter.svg": 5904,
	"./AgencyHome.svg": 6560,
	"./AgencyInformCenter.svg": 8206,
	"./AgencyOptMenu.svg": 1720,
	"./AgencyOrderManagement.svg": 9527,
	"./AgencyOtherApply.svg": 6127,
	"./AgencyReturnManagement.svg": 1785,
	"./AgencyTransaction.svg": 2728,
	"./Deliver.svg": 955,
	"./DeliverCar.svg": 1060,
	"./DeliverSearch.svg": 3469,
	"./DownLoad.svg": 6098,
	"./Exit.svg": 6236,
	"./Help.svg": 5287,
	"./Home.svg": 8200,
	"./OperationMenu.svg": 6436,
	"./Order.svg": 8725,
	"./OrderArrival.svg": 8525,
	"./OrderImport.svg": 8959,
	"./OrderImportSer.svg": 9957,
	"./Profile.svg": 7073,
	"./PubPriceQuery.svg": 6002,
	"./PullDown.svg": 5597,
	"./QueryDeliveryTime.svg": 4142,
	"./ReconciliationSearch.svg": 8152,
	"./Report.svg": 9401,
	"./ReturnQuery.svg": 9683,
	"./SalDispatchList.svg": 9990,
	"./ShipmentQuery.svg": 5129,
	"./UrgentQuery.svg": 5894,
	"./account.svg": 6400,
	"./bulletin.svg": 635,
	"./changeaddress-blue.svg": 3554,
	"./changeaddress.svg": 3735,
	"./confirm.svg": 6010,
	"./database.svg": 3585,
	"./delete.svg": 8031,
	"./deny.svg": 224,
	"./downloadBillAccess.svg": 4022,
	"./downloadchange.svg": 9797,
	"./downloaddraw.svg": 9562,
	"./edit.svg": 7546,
	"./export.svg": 8407,
	"./inform.svg": 1361,
	"./itemCodeQuery.svg": 325,
	"./navbar.svg": 2265,
	"./newlydownload.svg": 9560,
	"./password.svg": 5739,
	"./print.svg": 8802,
	"./productPicture.svg": 7730,
	"./publication.svg": 2646,
	"./qmAbnQlyOrder.svg": 1833,
	"./salSalesOrder.svg": 5143,
	"./save.svg": 3309,
	"./selectrectangle.svg": 2193,
	"./uploadFileSelected.svg": 7550,
	"./vote.svg": 720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;